import { Injectable } from '@angular/core';
import { NgbTimeStruct, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class DateTimeStringAdapter {

  fromDateModel(value: string): NgbDateStruct {
    if (!value) {
      return null;
    }
    const split = value.split('-');
    return {
      year: parseInt(split[0], 10),
      month: parseInt(split[1], 10),
      day: parseInt(split[2], 10),
    };
  }

  /**
   * @paramvalue
   */
  fromTimeModel(value: Date|string): NgbTimeStruct {
    if (!value) {
      return null;
    }
    let split: any[];
    if (value instanceof Date) {
      split = [
        value.getHours(),
        value.getMinutes(),
        value.getSeconds(),
      ];
    } else if (typeof value === 'string') {
      value = value.includes('T') ? value.split('T')[1] : value;
      split = value.split(':');
    }
    return {
      hour: parseInt(split[0], 10),
      minute: parseInt(split[1], 10),
      second: parseInt(split[2].substr(0, 2), 10),
    };
  }

  pad(i: number): string {
    return i < 10 ? `0${i}` : `${i}`;
  }

  toModel(time: NgbTimeStruct): string {
    if (!time) {
      return null;
    }
    return `${this.pad(time.hour)}:${this.pad(time.minute)}:${this.pad(time.second)}`;
  }
}
